import { lazy } from 'react';

import type { TApplicationRoute } from '@modules/core/types';

import { HELP_CENTER_ROUTE_PATHS } from './config';

export const WORKFLOWS_ROUTES: TApplicationRoute[] = [
  {
    id: 'help-center-workflows',
    path: HELP_CENTER_ROUTE_PATHS.workflows,
    component: lazy(() => import('./pages/workflows-page')),
    layout: 'default',
    permissions: { scopes: ['help-center'] },
    menu: {
      title: 'pages.helpCenter.workflows.title',
    },
  },
];
